const locale = {
  'c.ApplyAccount.title': 'Подать заявку на открытие счета',
  'c.ApplyAccount.label.countryCode': 'Страна',
  'c.ApplyAccount.label.companyName': 'Название вашей компании',
  'c.ApplyAccount.label.userName': 'Ваше имя',
  'c.ApplyAccount.label.contactInformation': 'Ваш номер телефона или адрес электронной почты',
  'c.ApplyAccount.label.remark': 'Какие проблемы вы хотите решить с помощью casschoice?',
  'c.ApplyAccount.placeholder.pleaseSelect': 'Пожалуйста, выберите',
  'c.ApplyAccount.placeholder.pleaseEnter': 'Пожалуйста, введите',
  'c.ApplyAccount.placeholder.contactInformation':
    'Пожалуйста, введите ваш WhatsApp или адрес электронной почты',
  'c.ApplyAccount.button.submit': 'Зарегистрироваться',
  'c.ApplyAccount.text.disclaimerText':
    'Я прочитал и согласен с {serviceAgreement} и {privacyPolicy}',
  'c.ApplyAccount.text.agreeTextMessage': 'Я согласен получать текстовые сообщения',
  'c.ApplyAccount.text.notice':
    'Мы обработаем вашу заявку в течение 3 рабочих дней с момента получения и свяжемся с вами по электронной почте или WhatsApp. Пожалуйста, проверьте свои сообщения.',
  'c.ApplyAccount.disclaimerText.error':
    'Пожалуйста, сначала прочитайте и согласитесь с соглашением.',
  'c.ApplyAccount.agreeTextMessage.error':
    'Пожалуйста, сначала согласитесь получать текстовые сообщения.',
  'c.ApplyAccount.request.loading': 'Отправка...',
  'c.ApplyAccount.request.success':
    'Отправлено успешно, мы завершим вашу регистрацию в течение 3 рабочих дней',
  'c.ApplyAccount.request.error': 'Ошибка отправки! Пожалуйста, попробуйте позже.',
};

export default locale;
